<div
    class="cmps-coaching-detail-pillar-three--top"
    *ngIf="_siblingPillarsReady"
>
    <div class="cmps-coaching-detail-pillar-three--left">
        <div class="cmps-coaching-detail-pillar-three--info">
            <cmps-coaching-opp-item
                [label]="_opportunity?.label | translate"
                [goalBorderColour]="_opportunity?.goalBorderColour"
                [goalColour]="_opportunity?.goalColour"
                [goalLabel]="
                    (_opportunity?.goalLabel | translate) ||
                    (_opportunity?.percentToGoal == null
                        ? null
                        : (_opportunity?.percentToGoal / 100 | cmpsSdpPercent))
                "
                [goalLabelColour]="_opportunity?.goalLabelColour"
                [goalIcon]="_opportunity?.goalIcon"
                [goalBadgeColour]="_opportunity?.goalBadgeColour"
                [goalBadgeLabel]="_opportunity?.goalBadgeLabel"
                [goalBadgeLabelColour]="_opportunity?.goalBadgeLabelColour"
                [targetColour]="_opportunity?.targetColour"
                [targetLabel]="
                    (_opportunity?.targetLabel | translate) ||
                    (_opportunity?.percentToTarget == null
                        ? null
                        : (_opportunity?.percentToTarget / 100
                          | cmpsSdpPercent))
                "
                *ngIf="_opportunity"
            ></cmps-coaching-opp-item>

            <div *ngIf="!_opportunity">
                {{
                    _i18n._9560_PLEASE_SELECT_AN_OPPORTUNITY_ON_THE_LEFT_
                        | translate
                }}
            </div>
        </div>

        <div class="cmps-coaching-detail-pillar-three--actions">
            <button
                class="cmps-coaching-detail-pillar-three--actions-btn"
                cmpsButton
                (click)="_onStartObservationClick(true)"
            >
                <cmps-icon svgIcon="loupe"></cmps-icon>
                <span cmpsButtonLabel>{{
                    _i18n._9554_START_GENERIC_OBSERVATION | translate
                }}</span>
            </button>

            <button
                class="cmps-coaching-detail-pillar-three--actions-btn"
                cmpsButton
                (click)="_onStartCommitmentClick(true)"
            >
                <cmps-icon svgIcon="folder-account"></cmps-icon>
                <span cmpsButtonLabel>{{
                    _i18n._9555_START_GENERIC_COMMITMENT | translate
                }}</span>
            </button>
        </div>
    </div>

    <div class="cmps-coaching-detail-pillar-three--right">
        <button
            class="cmps-icon-button--no-bg cmps-coaching-detail-pillar-three--close"
            cmpsIconButton
            (click)="_onCloseToPulseClick()"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
</div>

<div
    class="cmps-coaching-detail-pillar-three--bottom"
    *ngIf="_siblingPillarsReady"
>
    <cmps-tabset
        [selectedTabRefId]="state?.chartType"
        (selectedTabRefIdChange)="_onChartTypeChange($event)"
    >
        <cmps-tabset-label-wrapper>
            <ng-template
                cmpsTabLabel
                [tabRefId]="_ChartType.VARIANCE"
                let-ctx
            >
                <button
                    cmpsTabButton
                    theme="a"
                    [selected]="ctx.selected"
                    (click)="ctx.select(_ChartType.VARIANCE)"
                >
                    <span cmpsTabButtonLabel>{{
                        _i18n._7398_VARIANCE | translate
                    }}</span>
                </button>
            </ng-template>
            <ng-template
                cmpsTabLabel
                [tabRefId]="_ChartType.TREND"
                let-ctx
            >
                <button
                    cmpsTabButton
                    theme="a"
                    [selected]="ctx.selected"
                    (click)="ctx.select(_ChartType.TREND)"
                >
                    <span cmpsTabButtonLabel>{{
                        _i18n._989_TREND | translate
                    }}</span>
                </button>
            </ng-template>
            <ng-template
                cmpsTabLabel
                [tabRefId]="_ChartType.DETAIL"
                let-ctx
            >
                <button
                    cmpsTabButton
                    theme="a"
                    [selected]="ctx.selected"
                    (click)="ctx.select(_ChartType.DETAIL)"
                >
                    <span cmpsTabButtonLabel>{{
                        _i18n._555_DETAIL | translate
                    }}</span>
                </button>
            </ng-template>
        </cmps-tabset-label-wrapper>
        <cmps-tabset-content-wrapper>
            <ng-template
                cmpsTabContent
                [tabRefId]="_ChartType.VARIANCE"
            >
                <ng-container *ngTemplateOutlet="periodTypeTpl"></ng-container>
                <ng-container *ngIf="state?.chartType === _ChartType.VARIANCE">
                    <ng-container *ngTemplateOutlet="chartTpl"></ng-container>
                </ng-container>

                <div class="cmps-coaching-detail-pillar-three--chart-legend">
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--stroke-blue-100"
                    >
                        <cmps-icon
                            svgIcon="cmps-coaching:solid-line-thick"
                        ></cmps-icon>
                        <span>{{ _i18n._7456_ACTUAL_LINE | translate }}</span>
                    </cmps-coaching-legend-item>
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--stroke-red-100"
                    >
                        <cmps-icon
                            svgIcon="cmps-coaching:solid-line-thick"
                        ></cmps-icon>
                        <span>{{
                            _i18n._7459_OPPORTUNITY_LINE | translate
                        }}</span>
                    </cmps-coaching-legend-item>
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--bg"
                    >
                        <cmps-icon svgIcon="folder-account"></cmps-icon>
                        <span>{{
                            _i18n._9457_COMMITMENT_EVENT | translate
                        }}</span>
                    </cmps-coaching-legend-item>
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--bg cmps-coaching-legend-item--bg-pink"
                    >
                        <cmps-icon svgIcon="calendar-text"></cmps-icon>
                        <span>{{
                            _i18n._9458_MULTIPLE_COACHING_EVENTS | translate
                        }}</span>
                    </cmps-coaching-legend-item>
                </div>
            </ng-template>
            <ng-template
                cmpsTabContent
                [tabRefId]="_ChartType.TREND"
            >
                <ng-container *ngTemplateOutlet="periodTypeTpl"></ng-container>
                <ng-container *ngIf="state?.chartType === _ChartType.TREND">
                    <!--TODO replace with uikit checkbox-->
                    <div class="cmps-coaching-detail-pillar-three--sg-avg">
                        <span>{{
                            _i18n._9429_SHOW_SUPERGROUP_AVG | translate
                        }}</span>
                        <input
                            type="checkbox"
                            [checked]="_graphSetSGToggles[0]"
                            (change)="
                                _graphSetSGToggles = [!_graphSetSGToggles[0]]
                            "
                        />
                    </div>
                    <ng-container *ngTemplateOutlet="chartTpl"></ng-container>
                </ng-container>

                <div class="cmps-coaching-detail-pillar-three--chart-legend">
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--stroke-green-100"
                    >
                        <cmps-icon
                            svgIcon="cmps-coaching:solid-line"
                        ></cmps-icon>
                        <span>{{ _i18n._7457_TARGET_LINE | translate }}</span>
                    </cmps-coaching-legend-item>
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--stroke-blue-100"
                    >
                        <cmps-icon
                            svgIcon="cmps-coaching:solid-line-thick"
                        ></cmps-icon>
                        <span>{{ _i18n._7456_ACTUAL_LINE | translate }}</span>
                    </cmps-coaching-legend-item>
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--stroke-yellow-100"
                    >
                        <cmps-icon
                            svgIcon="cmps-coaching:dashed-line"
                        ></cmps-icon>
                        <span>{{ _i18n._7458_GOAL_LINE | translate }}</span>
                    </cmps-coaching-legend-item>
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--fill-red-100"
                    >
                        <cmps-icon
                            svgIcon="cmps-coaching:circle-path"
                        ></cmps-icon>
                        <span>{{
                            _i18n._9480_SUPERGROUP_AVERAGE | translate
                        }}</span>
                    </cmps-coaching-legend-item>
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--bg cmps-coaching-legend-item--bg-yellow-100"
                    >
                        <cmps-icon svgIcon="flag"></cmps-icon>
                        <span>{{ _i18n._9454_ACTIVE_GOAL | translate }}</span>
                    </cmps-coaching-legend-item>
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--fill-grey-400"
                    >
                        <cmps-icon svgIcon="cmps-coaching:circle"></cmps-icon>
                        <span>{{
                            _i18n._9455_HISTORIC_GOALS | translate
                        }}</span>
                    </cmps-coaching-legend-item>
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--bg"
                    >
                        <cmps-icon svgIcon="folder-account"></cmps-icon>
                        <span>{{
                            _i18n._9457_COMMITMENT_EVENT | translate
                        }}</span>
                    </cmps-coaching-legend-item>
                    <cmps-coaching-legend-item
                        class="cmps-coaching-legend-item--bg cmps-coaching-legend-item--bg-pink"
                    >
                        <cmps-icon svgIcon="calendar-text"></cmps-icon>
                        <span>{{
                            _i18n._9458_MULTIPLE_COACHING_EVENTS | translate
                        }}</span>
                    </cmps-coaching-legend-item>
                </div>
            </ng-template>
            <ng-template
                cmpsTabContent
                [tabRefId]="_ChartType.DETAIL"
            >
                <ng-container *ngTemplateOutlet="periodTypeTpl"></ng-container>
                <cmps-detail-grid
                    [dates]="state?.dates"
                    [data]="state?.periodPerf"
                ></cmps-detail-grid>
            </ng-template>
        </cmps-tabset-content-wrapper>
    </cmps-tabset>

    <ng-container *ngIf="_opportunity">
        <ng-container *ngTemplateOutlet="oppActionGrpTpl"></ng-container>
    </ng-container>
</div>

<ng-template #oppActionGrpTpl>
    <cmps-coaching-opportunity-action-group
        [coached]="_coached"
        [coachedLabel]="
            (isPending && _coached
                ? _i18n._9818_THIS_METRIC_HAS_A_PENDING_GOAL_IN_PROGRESS
                : _i18n._9557_DO_YOU_WANT_TO_OBSERVE_OR_COMMIT_A_NEW_FOCUS_FOR_THIS_METRIC_
            ) | translate
        "
        [uncoachedLabel]="
            _i18n._9817_DO_YOU_WANT_TO_OBSERVE_OR_COMMIT_A_FOCUS_FOR_THIS_METRIC
                | translate
        "
        [hasObservationAction]="true"
        [observationActionLabel]="_i18n._9559_NEW_OBSERVATION | translate"
        (observationAction)="_onStartObservationClick(false)"
        [hasCommitmentAction]="true"
        [commitmentActionLabel]="_i18n._9775_NEW_COMMITMENT | translate"
        (commitmentAction)="_onStartCommitmentClick(false)"
    ></cmps-coaching-opportunity-action-group>
</ng-template>

<ng-template #periodTypeTpl>
    <cmps-button-group
        class="cmps-coaching-detail-pillar-three--periods"
        [value]="state?.periodTypeId"
    >
        <button
            cmpsButtonGroupItem
            [value]="_PeriodType.ROLLING_30"
            (click)="_onPeriodTypeClick(_PeriodType.ROLLING_30)"
        >
            {{ _i18n._714__30_DAY | translate }}
        </button>
        <button
            cmpsButtonGroupItem
            [value]="_PeriodType.DAY"
            (click)="_onPeriodTypeClick(_PeriodType.DAY)"
            *ngIf="state?.chartType !== _ChartType.DETAIL"
        >
            {{ _i18n._202_DAILY | translate }}
        </button>
        <button
            cmpsButtonGroupItem
            [value]="_PeriodType.WEEK"
            (click)="_onPeriodTypeClick(_PeriodType.WEEK)"
        >
            {{ _i18n._203_WEEKLY | translate }}
        </button>
        <button
            cmpsButtonGroupItem
            [value]="_PeriodType.MONTH"
            (click)="_onPeriodTypeClick(_PeriodType.MONTH)"
        >
            {{ _i18n._204_MONTHLY | translate }}
        </button>
    </cmps-button-group>
</ng-template>

<ng-template #chartTpl>
    <div class="cmps-coaching-detail-pillar-three--chart-wrapper">
        <ng-chart-line-area
            [graphSet]="_graphSet"
            [graphSetSGToggles]="
                state?.chartType === _ChartType.VARIANCE
                    ? null
                    : _graphSetSGToggles
            "
            [isVariance]="state?.chartType === _ChartType.VARIANCE"
            [customHeight]="250"
            [maxTooltipHeight]="150"
            [maxTooltipWidth]="180"
            *ngIf="!state?.pending?.reloadChart && this._graphSet"
        >
            <ng-template
                lineAreaChartEventCallout
                let-data="data"
            >
                <cmps-coaching-event-box
                    [events]="data"
                ></cmps-coaching-event-box>
            </ng-template>
            <ng-template
                lineAreaChartGoalCallout
                let-data="data"
            >
                <cmps-coaching-goal-box
                    [goalLabel]="_i18n._721_GOAL | translate"
                    [goal]="
                        data?.goalValue == null
                            ? '-'
                            : (data?.goalValue | number: '1.0-2')
                    "
                    [pctToGoalLabel]="_i18n._767___TO_GOAL | translate"
                    [pctToGoal]="
                        data?.currentPctGoal == null
                            ? '-'
                            : (data?.currentPctGoal | percent: '1.0-2')
                    "
                    [pctToTargetLabel]="_i18n._768___TO_TARGET | translate"
                    [pctToTarget]="
                        data?.percentToTarget == null
                            ? '-'
                            : (data?.percentToTarget | percent: '1.0-2')
                    "
                ></cmps-coaching-goal-box>
            </ng-template>
        </ng-chart-line-area>
        <div
            class="cmps-coaching-detail-pillar-three--chart-no-data"
            *ngIf="
                !state?.pending?.reloadChart &&
                this._graphSet &&
                this._graphSet[0]?.showEmptyGraph
            "
        >
            {{ _i18n._9430_NO_METRIC_PERFORMANCE_DATA | translate }}
        </div>
    </div>
</ng-template>
